import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../hooks/useContent';
import { FacebookIcon } from './icons/social/FacebookIcon';
import { InstagramIcon } from './icons/social/InstagramIcon';
import { PinterestIcon } from './icons/social/PinterestIcon';
import { ThreadsIcon } from './icons/social/ThreadsIcon';
import { YouTubeIcon } from './icons/social/YouTubeIcon';
import { LinkedInIcon } from './icons/social/LinkedInIcon';

const socialIcons = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  pinterest: PinterestIcon,
  threads: ThreadsIcon,
  youtube: YouTubeIcon,
  linkedin: LinkedInIcon,
};

export const Footer: React.FC = () => {
  const { footerNav, socialLinks } = useContent();
  
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto py-6 px-4 sm:px-6 lg:px-8 text-center text-sm text-[#6B7280]">
        <div className="flex justify-center items-center flex-wrap gap-x-4 gap-y-2">
          {footerNav?.links.map((link, index) => (
            <React.Fragment key={link.id}>
              <Link to={link.path} className="hover:underline">
                {link.name}
              </Link>
              {index < footerNav.links.length - 1 && <span className="text-gray-400">|</span>}
            </React.Fragment>
          ))}
        </div>
        <div className="flex justify-center items-center space-x-6 mt-4">
          {socialLinks && Object.entries(socialLinks).map(([platform, url]) => {
            if (url) {
              const Icon = socialIcons[platform as keyof typeof socialIcons];
              return (
                <a key={platform} href={url} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-700 transition-colors" aria-label={`Follow us on ${platform}`}>
                  <Icon className="h-5 w-5" />
                </a>
              );
            }
            return null;
          })}
        </div>
        <p className="mt-4">
          &copy; {new Date().getFullYear()} BrandGenius. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
